import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { SingleSelectField } from "@saleor/components/SingleSelectField";
import { makeStyles } from "@saleor/macaw-ui";
import React, { useState } from "react";
import { useIntl } from "react-intl";

interface DialogConfirmWarningProps {
  onCancel: () => void;
  onConfirm: (value) => void;
  open: boolean;
  loading?: boolean;
  testId?: string;
}

const useStyles = makeStyles(
  theme => ({
    root: {
      "& .MuiPaper-root": {
        maxWidth: 440,
        width: "100%",
        borderRadius: 16
      },
      "& .MuiDialogTitle-root": {
        padding: 24
      },
      "& .MuiDialogContent-root": {
        paddingTop: 5,
        marginBottom: "1rem",
        "& .MuiFormControl-root": {
          height: 40
        }
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24,
        columnGap: 16
      },
      "& .MuiButton-root": {
        fontSize: "1.8rem",
        "& .MuiTypography-root": {
          fontSize: "1.8rem"
        }
      }
    },
    title: {
      color: theme.palette.error.light
    },
    btnAction: {
      height: 48,
      "&.MuiButton-containedPrimary .MuiTypography-root": {
        color: "#ffffff"
      }
    },
    titleContent: {
      marginBottom: "2.4rem"
    },
    selectCancel: {
      "& .MuiSelect-root b": {
        fontWeight: 400
      }
    }
  }),
  { name: "DialogConfirmDelete" }
);

const DialogConfirmCancelItem: React.FC<DialogConfirmWarningProps> = ({
  onCancel,
  onConfirm,
  open,
  loading,
  testId
}) => {
  const classes = useStyles();
  const intl = useIntl();
  const [selectValue, setSelectValue] = useState<string>("Cancel");

  const reasonChoices = [
    { value: "Cancel", label: <b>Cancel 93</b> },
    { value: "Delete", label: <b>Delete</b> }
  ];

  const setReasonCancel = e => {
    setSelectValue(e.target.value);
  };

  const handleSubmit = () => {
    if (selectValue) {
      onConfirm(selectValue);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      className={classes.root}
      data-testid={testId ?? "dialogConfirmCancelItem"}
    >
      <DialogTitle>
        <MyTypography variant="h6" className={classes.title}>
          Cancel item สินค้าที่เลือก
        </MyTypography>
      </DialogTitle>
      <DialogContent>
        <MyTypography variant={"body2"} className={classes.titleContent}>
          กรุณาระบุ Reason for reject และกด “ยืนยัน” หรือกด “กลับไป”
          เพื่อปิดหน้าต่างนี้
        </MyTypography>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Reason for reject" })}
        </MyTypography>
        <SingleSelectField
          placeholder={"Select"}
          choices={reasonChoices}
          onChange={setReasonCancel}
          value={selectValue}
          className={classes.selectCancel}
        />
      </DialogContent>
      <DialogActions disableSpacing={true}>
        <Button
          data-testid="backButton"
          color="primary"
          variant="outlined"
          className={classes.btnAction}
          fullWidth={true}
          onClick={onCancel}
          disabled={loading}
        >
          <MyTypography variant="body1">
            {intl.formatMessage({ defaultMessage: "กลับไป" })}
          </MyTypography>
        </Button>
        <Button
          data-testid="confirmButton"
          color="primary"
          variant="contained"
          className={classes.btnAction}
          fullWidth={true}
          onClick={handleSubmit}
          disabled={loading}
        >
          <MyTypography variant="body1">
            {intl.formatMessage({ defaultMessage: "ยืนยัน" })}
          </MyTypography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirmCancelItem;
